export const TAG_ORGANIZATION_USERS = 'ORGANIZATION_USERS'
export const TAG_ORGANIZATIONS = 'ORGANIZATIONS'
export default [TAG_ORGANIZATIONS, TAG_ORGANIZATION_USERS]
